import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { CamerasFilterCard } from "~/components/Filters/CamerasFilter/components/CamerasFilterCard";
import { PublicCameraMakeSelect } from "~/components/Filters/CamerasFilter/components/PublicCameraMakeSelect";
import { PublicCameraModelsSelect } from "~/components/Filters/CamerasFilter/components/PublicCameraModelsSelect";
export const PublicCamerasFilterCard = /*#__PURE__*/ memo((param)=>{
    let { boardId, ...props } = param;
    const renderStringSelect = useCallback((props)=>/*#__PURE__*/ _jsx(PublicCameraModelsSelect, {
            boardId: boardId,
            ...props
        }), [
        boardId
    ]);
    const renderMakeSelect = useCallback((props)=>/*#__PURE__*/ _jsx(PublicCameraMakeSelect, {
            boardId: boardId,
            ...props
        }), [
        boardId
    ]);
    return /*#__PURE__*/ _jsx(CamerasFilterCard, {
        CameraModelsSelect: renderStringSelect,
        CameraMakeSelect: renderMakeSelect,
        ...props
    });
});
PublicCamerasFilterCard.displayName = "PublicCamerasFilterCard";
